/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
import isArray from"./isArray";import isUndefined from"./isUndefined";const toQueryString=function(e){let n=[],t=function(e,n){return isUndefined(n)?e:`${e}=${encodeURIComponent(null===n?"":String(n))}`};return e.forEach((e=>{let o,r,i,f,s=encodeURIComponent(e.key),u=e.value;if(u&&"object"==typeof u){if(isArray(u)){for(o=0,r=u.length,f=[];o<r;o++)i=u[o],f.push(t(s,i));n=n.concat(f)}}else n.push(t(s,u))}),this),n.join("&")};export default toQueryString;